/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, done: NonNullable<unknown>, total: NonNullable<unknown> }} Action_Bar_Playing_RoundInputs */



/**
* | output |
* | --- |
* | "Round {n} in progress. {done}/{total} tables finished." |
*
* @param {Action_Bar_Playing_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_playing_round = /** @type {((inputs: Action_Bar_Playing_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Playing_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} en cours. ${i?.done}/${i?.total} tables terminées.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} en curso. ${i?.done}/${i?.total} mesas terminadas.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} em andamento. ${i?.done}/${i?.total} mesas terminadas.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} in corso. ${i?.done}/${i?.total} tavoli terminati.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} in progress. ${i?.done}/${i?.total} tables finished.`)
});